import React from 'react'

import { Link } from 'react-router-dom'
import styles from './bill-card.module.css'
import Helper from './Helper';

function BillCard(props) {
  const { getButtonStyle } = Helper();

  return (
    <div className={styles.card}>
      <table frame="shides" rules="rows">
        <tbody>
          <tr className={styles.tr}>
            <td className={styles.label}>Kurum</td>
            <td className={styles.value}>{props.invoice.corpName}</td>
          </tr>
          <tr className={styles.tr}>
            <td className={styles.label}>Fatura No</td>
            <td className={styles.value}>{props.invoice.invoiceNo}</td>
          </tr>
          <tr className={styles.tr}>
            <td className={styles.label}>Tutar</td>
            <td className={styles.value}>{props.invoice.invoiceAmount}</td>
          </tr>
          <tr className={styles.tr}>
            <td className={styles.label}>Son Ödeme Tarihi</td>
            <td className={styles.value}>{props.invoice.formattedInvoiceDueDate}</td>
          </tr>

          <tr className={styles.tr}>
            <td className={styles.label}>Hizmet Bedeli</td>
            <td className={styles.value}>{props.invoice.commissionAmount}</td>
          </tr>
          <tr className={styles.tr}>
            <td className={styles.label}>Toplam Tutar</td>
            <td className={styles.value}>{props.invoice.totalAmount}</td>
          </tr>
        </tbody>
      </table>
      <div>

        <Link
          to={{
            pathname: `/payment/${props.invoice.corpCode}/${props.invoice.invoiceNo}`,
            invoice: props.invoice
          }}
        >
          <button className={styles.button} style={getButtonStyle()}>Ödeme Yap</button>
        </Link>
        {/*<Button as={Link} className={styles.buttonStyle}*/}
        {/*        to={`/payment/${this.props.corp.corpCode}/${this.props.invoice.invoiceNo}`}>*/}
        {/*    <Button.Content visible>Ödeme Yap</Button.Content>*/}
        {/*</Button>*/}
      </div>

      {/*<Link to="/payment">*/}
      {/*    <button type="button" className={styles.button}>*/}
      {/*        Odeme Yap*/}
      {/*    </button>*/}
      {/*</Link>*/}
    </div>
  )
}

export default BillCard
